"use strict";

exports.__esModule = true;
exports.setValue = exports.getValues = exports.getValue = void 0;

var _wixSdkPolyfill = _interopRequireDefault(require("./wix-sdk-polyfill"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SCOPE_OPTIONS = {
  scope: 'COMPONENT'
};

var getValue = function getValue(key) {
  return new Promise(function (resolve, reject) {
    _wixSdkPolyfill["default"].Data.Public.get(key, SCOPE_OPTIONS, resolve, reject);
  });
};

exports.getValue = getValue;

var getValues = function getValues(keys) {
  return Promise.all(keys.map(function (key) {
    return getValue(key);
  }));
};

exports.getValues = getValues;

var setValue = function setValue(key, value) {
  return new Promise(function (resolve, reject) {
    _wixSdkPolyfill["default"].Data.Public.set(key, value, SCOPE_OPTIONS, resolve, reject);
  });
};

exports.setValue = setValue;